import BasePlugin from './base-plugin'
import { vjs_El, vjs_find } from './utils'

class RatePlugin extends BasePlugin {
  constructor(player, _options) {
    super(player)

    const mainMenuItemEl = vjs_El('li', 'vjs-settings-item vjs-extend-speed vjs-menu-forward', 'Speed<span>Normal</span>')
    mainMenuItemEl.ariaDisabled = 'false'
    mainMenuItemEl.ariaLabel = 'Open media speed menu'
    mainMenuItemEl.role = 'menuitem'

    mainMenuItemEl.onclick = mainMenuItemEl.ontouchend = (e) => {
      e.preventDefault()
      e.stopImmediatePropagation()
      player.trigger('settings:showSubMenu', 'speedMenu')
    }

    const subMenuEl = vjs_El('div', 'vjs-submenu vjs-menu-speed vjs-hidden')
    subMenuEl.innerHTML = '<div class="vjs-settings-back">Speed</div>'
    const subMenuUlEl = vjs_El('ul', 'vjs-menu-content vjs-sub-menu')
    let rates = [0.5, 1, 1.25, 1.5, 2]
    if (player.playbackRates().length > 0) {
      rates = player.playbackRates()
    }
    player.playbackRates(rates)
    rates.forEach((rate) => {
      let className = 'vjs-menu-item vjs-speed'
      if (rate === 1) {
        className += ' vjs-checked'
      }

      const rateLiEl = this.dom.createEl('li', {
        className,
      }, {
        'role': 'menuitemradio',
        'aria-label': `Set Speed ${rate}`,
      }, `${rate}x`)

      rateLiEl.onclick = rateLiEl.ontouchend = (_e) => {
        player.playbackRate(rate)
        // handleControlClick('')
      }

      subMenuUlEl.appendChild(rateLiEl)
    })

    subMenuEl.appendChild(subMenuUlEl)
    player.SettingsMenuPlugin().addMenu('speedMenu', mainMenuItemEl, subMenuEl)

    player.on('ratechange', () => {
      const i = player.playbackRate()
      this.playerElement.querySelectorAll('.vjs-speed').forEach((e) => {
        const t = Number(e.innerHTML.replace('x', ''))
        this.dom.removeClass(e, 'vjs-checked')
        if (i === t) {
          this.dom.addClass(e, 'vjs-checked')
        }
      })
      vjs_find(this.playerElement, '.vjs-extend-speed span').innerHTML = `${i}x`
    })
  }
}

export default RatePlugin
